<template>
  <div class="loginindex">
    <img class="logo" src="../assets/loginlogo.png" />
    <div class="logotitle">猎头互助平台     /     猎头好帮手     /     找好猎头上聘快快</div>
    <div class="pkkQrfd">
        <img src='../assets/QR.png'/>
        <p>请使用微信【扫一扫】即可进入【聘快快】</p>
    </div>
    <div class="rightbox">
      <div class="logoBody">
        <div class="statusbox" v-if="loginStatus">
            <p class='qrtext1'>登录</p>
            <div class="qrcont" v-bind:style="{backgroundImage: 'url(' + qrUrl + ')'}" v-loading="qrloading" element-loading-text="二维码加载中"></div>
            <p class='qrtext'>请在<br/>【聘快快】<br/>小程序中扫描该二维码进行登录</p>
            <!-- <p class='actionbtn' @click="changeStatus">企业管理员登录</p> -->
        </div>
        <!-- <div class="statusbox" v-if="!loginStatus" v-loading="compLoading" element-loading-text="正在登录" element-loading-background="rgba(0, 0, 0, 0.8)">
          <p class='qrtext3'>企业管理员登录</p>
          <p class='qrtext2'>账号邮箱</p>
          <el-input style="margin-top:30px" placeholder="请输入企业管理员账号" prefix-icon="el-icon-user" v-model="companyEmail">
          </el-input>
          <p class='qrtext2'>密码</p>
          <el-input type="password" style="margin-top:20px" placeholder="请输入企业管理员密码" prefix-icon="el-icon-key" v-model="companyPassword">
          </el-input>
          <el-button style="margin-top:40px" type="success" class="sumbitBtn" @click='goCompany'>登录</el-button>
          <p class='actionbtn' @click="changeStatus">HR登录</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
import { setInterval } from "timers";
let QRCode = require("qrcode");
export default {
  name: "login",
  props: {},
  data() {
    return {
      uuid: "",
      qrUrl: "",
      qrloading: false,
      loginZt: "hr",
      compLoading: false,
      companyEmail: "",
      companyPassword: "",
      loginStatus: true,
      callbackurl: false
    };
  },
  watch: {},
  created: function() {},
  methods: {
    changeStatus: function () {
      this.loginStatus = !this.loginStatus
    },
    pdsq: function() {
      if (
        localStorage.getItem("token") === "" ||
        localStorage.getItem("token") === undefined ||
        localStorage.getItem("token") === null
      ) {
        this.getQr();
        this.openSetTime();
      }
    },

    getQr: function() {
      let that = this;
      let url = Config.path + "/api/candidate/qRcode/getqRcodeUUID";
      that.qrloading = true;
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          console.log(response);
          if (response.data.success === "1") {
            that.uuid = response.data.content.uuId;
            QRCode.toDataURL(that.uuid,{
                color: {
                  dark:"#5cc2cf",
                  light:"#ffffff"
                }
            }, function(err, url) {
              that.qrUrl = url;
              that.qrloading = false;
            });
            that.initWebsocket();
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          that.loading = false;

          // eslint-disable-next-line
          console.log(error);
        });
    },
    initWebsocket: function() {
      let path = Config.wssPath + "/api/candidate/websocket/";
      this.websocket = new WebSocket(path + this.uuid);
      this.websocket.onopen = this.websocketonopen;
      this.websocket.onerror = this.websocketonerror;
      this.websocket.onmessage = this.websocketonmessage;
      this.websocket.onclose = this.websocketclose;
    },
    websocketonopen: function() {
      console.log("WebSocket连接成功");
    },
    websocketonerror: function(e) {
      //错误
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage: function(e) {
      

      //数据接收
      if (e.data === "00000") {
        this.$notify({
          title: "警告",
          message:
            "sorry,您尚未在聘快快平台注册，请前往聘快快公众号，点击【我是猎头】进行注册",
          type: "warning",
          duration: 0
        });
      }
      const redata = JSON.parse(e.data);
      this.$store.commit("setUser", redata);
      console.log(this.$store.state);
      localStorage.setItem("token", redata.openid);
      localStorage.setItem("nickname", redata.nickname);
      localStorage.setItem("avatarPath", redata.avatarPath);
      this.avater = redata.avatarPath;
      this.nickname = redata.nickname;
      this.$notify({
        title: "提示",
        message: "登录成功",
        type: "success",
        duration: 1000
      });
      

      

      this.loginState = false;
      this.$router.push({
        path: this.callbackurl,
      })
    },

    websocketsend: function(agentData) {
      //数据发送
      this.websocket.send(agentData);
    },
    websocketclose: function(e) {
      //关闭
      console.log("connection closed (" + e.code + ")");
    },
    openSetTime: function() {
      let that = this;
      setInterval(function() {
        if (
          localStorage.getItem("token") === "" ||
          localStorage.getItem("token") === undefined ||
          localStorage.getItem("token") === null
        ) {
          that.getQr();
        }
      }, 160000);
    },
    goCompany: function() {
      let that = this;
      if (that.companyEmail === "" || that.companyEmail === undefined) {
        that.$message.warning("请输入管理员账号");
        return false;
      }
      if (that.companyPassword === "" || that.companyPassword === undefined) {
        that.$message.warning("请输入管理员密码");
        return false;
      }
      this.compLoading = true;
      let url = Config.path + "/api/enterprise//admin/logoin";
      axios({
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          accountName: this.companyEmail,
          password: this.companyPassword
        }
      })
        .then(function(response) {
          console.log(response);
          if (response.data.success === "1") {
            that.$store.commit("setUser", response.data.content);
            localStorage.setItem("token", response.data.content.adminToken);
            that.$notify({
              title: "提示",
              message: "登录成功",
              type: "success",
              duration: 1000
            });
            that.$router.push({
              path: "/hrManagement"
            });
            that.compLoading = false;
          } else {
            that.compLoading = false;
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          that.loading = false;

          // eslint-disable-next-line
          console.log(error);
        });
    }
  },
  mounted: function() {
    

    this.callbackurl = this.$route.query.callbackurl ? this.$route.query.callbackurl : '/'
    this.pdsq();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.loginindex {
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-image: url('../assets/loginbg.png');
  background-position: center top;
  background-size: 100% auto;
  background-repeat: no-repeat;
  min-height: 100vh;

  .logo{
    width: 216.5px;
    height: 67.8px;
    margin: 103px auto 0 auto;
  }

  .logotitle{
    color: #ffffff;
    font-size: 18px;
    font-weight: 290;
    line-height: 24px;
    margin-top: 37.6px;
  }

  .statusbox{
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
  }
  .actionbtn{
    color: #000000;
    padding-top: 20px;
    text-align: center;
  }
  .qrcont {
    margin: 20px auto 0 auto;
    width: 300px;
    height: 300px;
    background-size: 100%, 100%;
  }

  .sumbitBtn{
    width: 100%;
    background: #5cc2cf;
    display: block;
    margin: 0 auto;
  }

  .qrtext1 {
    color: #5cc2cf;
    padding-top: 60px;
    text-align: center;
  }

  .qrtext2 {
    color: #5cc2cf;
    padding-top: 30px;
    text-align: left;
  }

  .qrtext3 {
    color: #5cc2cf;
    padding-top: 60px;
    padding-bottom: 50px;
    text-align: center;
  }

  .qrtext {
    color: #5cc2cf;
    padding-top: 20px;
    text-align: center;
  }

  .el-tab-pane {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-tabs__item {
    color: #ffffff;
  }
  .pkkQrfd {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    background-color: transparent;
    border-radius: 8px;
    padding: 20px;
    position: fixed;
    right: 30px;
    bottom: 30px;
    img {
      width: 129px;
      border-radius: 100%;
      padding: 10px;
    }
    p {
      color: #ffffff;
      text-align: center;
      font-size: 12px;
      padding-top: 20px;
    }
  }
  .rightbox {
        width: 410px;
        height: 550px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 23px;
        .logoBody {
          width: 410px;
          height: 550px;
          position: relative;
          background-color: #ffffff;
          border-radius: 10px;
            .qrbtn{
                position: absolute;
                right: 5px;
                bottom: 5px;
                width: 100px;
                height: 100px;
            }
        }
      }
}
</style>
